import React, { useState } from "react";
import { Checkbox, Switch } from "antd";
import { Link } from "react-router-dom";
import firebase from "firebase";
import { useAlert } from "react-alert";

const UsersList = ({
  togle,
  ActiveUserss,
  setoptimiser1,
  setdataAdmin1,
  setActive1,
  setmanagerr1,
  setsimulator1,
  setCrew1,
  setGround1,
  setAircraft1,
  simulator1,
  ground1,
  crew1,
  aircraft1,
  managerr1,
  Active1,
  getusers,
  users,
  ActiveUserssCrews,
  ActiveUserssGroundss,
  ActiveUsersssimulatorss,
  ActiveUserssaircraft,
  crew_actives,
  aircraft_actives,
  ground_activs,
  simulator_actives,
  users_actives,
  userregister,
}) => {
  const [search, setSearch] = useState("");
  const alert = useAlert();

  function onChangeHandler(e, v) {
    if (v === "active") {
      setActive1(e.target.checked);
    } else if (v === "Crew") {
      setCrew1(e.target.checked);
    } else if (v === "Ground") {
      setGround1(e.target.checked);
    } else if (v === "Simulator") {
      setsimulator1(e.target.checked);
    } else if (v === "Aircraft") {
      setAircraft1(e.target.checked);
    } else if (v === "Manager") {
      setmanagerr1(e.target.checked);
    } else if (v === "Optimiser") {
      setoptimiser1(e.target.checked);
    } else if (v === "DataAdmin") {
      setdataAdmin1(e.target.checked);
    }
  }
  return (
    <div>
      <div className="category-title">Users</div>
      <div className="table-body-container">
        <div className="table-body-header">All Users</div>
        <div className="client-list-divider"></div>
        <div className="table-container">
          <div className="table-header-container">
            <div className="active-switch">
              <span>Active User</span>
              <Switch onClick={togle} defaultChecked />
            </div>
            <div className="search-bar">
              <span>Search</span>
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          {users !== {} && getusers !== undefined
            ? getusers?.aatmsv4_users?.map((data, index) => {
                if (data?.email.toLowerCase().includes(search.toLowerCase())) {
                  return (
                    <div className="table-row-container" key={index}>
                      <div className="usersList">
                        <div className="items">
                          <div className="title">Feets</div>
                          <div className="value">{data?.fleet?.aircraft}</div>
                        </div>
                        <div className="items">
                          <div className="title">Email/Username</div>
                          <div className="value">{data?.email}</div>
                        </div>
                        <div className="items usersList__checkbox">
                          <div style={{ margin: "10px 0px" }}>
                            <span style={{ margin: "0px 11px" }}>Active</span>{" "}
                            <Checkbox
                              defaultChecked={data?.active}
                              onChange={(e) => onChangeHandler(e, "active")}
                            ></Checkbox>
                            <span style={{ margin: "0px 11px" }}>Crew</span>{" "}
                            <Checkbox
                              defaultChecked={data?._crew}
                              onChange={(e) => onChangeHandler(e, "Crew")}
                            ></Checkbox>
                            <span style={{ margin: "0px 11px" }}>Ground</span>{" "}
                            <Checkbox
                              defaultChecked={data?._ground}
                              onChange={(e) => onChangeHandler(e, "Ground")}
                            ></Checkbox>
                            <span style={{ margin: "0px 11px" }}>
                              Simulator
                            </span>
                            <Checkbox
                              defaultChecked={data?._simulator}
                              onChange={(e) => onChangeHandler(e, "Simulator")}
                            ></Checkbox>
                            <span style={{ margin: "0px 11px" }}>Aircraft</span>
                            <Checkbox
                              defaultChecked={data?._aircraft}
                              style={{ marginRight: "70px" }}
                              onChange={(e) => onChangeHandler(e, "Aircraft")}
                            ></Checkbox>
                          </div>
                        </div>

                        <div className="usersList__button">
                          {/* <Link to="/dashboard/manager" className="roles-items"> */}

                          {/* <Link className="roles-items"> */}
                          <button
                            style={{ width: "70px", margin: "10px 0px" }}
                            className="submit-button"
                            onClick={() => {
                              if (Active1 === false) {
                                ActiveUserss({
                                  variables: {
                                    id:
                                      data?.userid ||
                                      data?.crewid ||
                                      data?.managersid,
                                    Crew: Active1,
                                    Ground: Active1,
                                    Simulator: Active1,
                                    Aircraft: Active1,
                                    active: Active1,
                                  },
                                });
                                ActiveUserssCrews({
                                  variables: {
                                    id:
                                      data?.userid ||
                                      data?.managersid ||
                                      data?.crewid,
                                    active: Active1,
                                  },
                                });
                                ActiveUserssGroundss({
                                  variables: {
                                    id:
                                      data?.userid ||
                                      data?.managersid ||
                                      data?.crewid,
                                    active: Active1,
                                  },
                                });
                                ActiveUsersssimulatorss({
                                  variables: {
                                    id:
                                      data?.userid ||
                                      data?.managersid ||
                                      data?.crewid,
                                    active: Active1,
                                  },
                                });
                                ActiveUserssaircraft({
                                  variables: {
                                    id:
                                      data?.userid ||
                                      data?.managersid ||
                                      data?.crewid,
                                    active: Active1,
                                  },
                                });
                                setTimeout(() => {
                                  async function setDocument(db) {
                                    const datas = {
                                      _aircraft: Active1,
                                      _crew: Active1,
                                      _ground: Active1,
                                      _manager: Active1,
                                      _simulator: Active1,
                                      _optimiser: Active1,
                                      _dataadmin: Active1,
                                      active: Active1,
                                      clientid: data?.client?.clientsid,
                                      clientname: data?.client?.clientname,
                                      email: data.email,
                                    };
                                    const res = await firebase
                                      .firestore()
                                      .collection("users")
                                      .doc(
                                        data?.managersid ||
                                          data?.crewid ||
                                          data?.userid
                                      )
                                      .set(datas);
                                  }
                                  setDocument();
                                }, 2000);
                              } else if (Active1 === true) {
                                users_actives({
                                  variables: {
                                    id:
                                      data?.userid ||
                                      data?.crewid ||
                                      data?.managersid,
                                    Crew: crew1,
                                    Ground: ground1,
                                    Simulator: simulator1,
                                    Aircraft: aircraft1,
                                    active: Active1,
                                  },
                                });
                                userregister({
                                  variables: {
                                    id:
                                      data?.userid ||
                                      data?.crewid ||
                                      data?.managersid,
                                    Crew: crew1,
                                    Ground: ground1,
                                    Simulator: simulator1,
                                    Aircraft: aircraft1,
                                  },
                                });

                                crew_actives({
                                  variables: {
                                    id:
                                      data?.userid ||
                                      data?.crewid ||
                                      data?.managersid,
                                    Crew: crew1,
                                  },
                                });
                                aircraft_actives({
                                  variables: {
                                    id:
                                      data?.userid ||
                                      data?.crewid ||
                                      data?.managersid,
                                    Aircraft: aircraft1,
                                  },
                                });
                                ground_activs({
                                  variables: {
                                    id:
                                      data?.userid ||
                                      data?.crewid ||
                                      data?.managersid,
                                    Ground: ground1,
                                  },
                                });

                                simulator_actives({
                                  variables: {
                                    id:
                                      data?.userid ||
                                      data?.crewid ||
                                      data?.managersid,
                                    Simulator: simulator1,
                                  },
                                });
                                setTimeout(() => {
                                  async function setDocument(db) {
                                    const datas = {
                                      _aircraft: aircraft1,
                                      _crew: crew1,
                                      _ground: ground1,
                                      _simulator: simulator1,
                                      active: Active1,
                                      _manager: data?._manager,
                                      clientid: data?.client?.clientsid,
                                      clientname: data?.client?.clientname,
                                      _optimiser: data?._optimiser,
                                      _dataadmin: data?._dataadmin,
                                      email: data.email,
                                    };
                                    const res = await firebase
                                      .firestore()
                                      .collection("users")
                                      .doc(
                                        data?.managersid ||
                                          data?.crewid ||
                                          data?.userid
                                      )
                                      .set(datas);
                                    console.log(res);
                                  }
                                  setDocument();
                                }, 3000);
                              }
                            }}
                          >
                            Update
                          </button>
                          {/* </Link> */}
                        </div>
                      </div>
                    </div>
                  );
                }
              })
            : null}
        </div>
      </div>
      {/* <div className="print-email-container">
        <button className="submit-button" style={{ marginTop: "unset" }}>
          <i className="fa fa-download" />
          Download
        </button>
        <button className="print-button">
          <i className="fa fa-print" />
          Print
        </button>
        <button className="email-button">
          <i className="fa fa-envelope" />
          Email
        </button>
      </div> */}
    </div>
  );
};

export default UsersList;
